(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('RemoveImgTagFilter', [RemoveImgTagFilterFn]);

    // removes images (img-tags) from html strings
    function RemoveImgTagFilterFn() {
        return function (htmlString) {
            return htmlString.replace(/<img[^>]*>/g, '');
        };
    }
})();
